import React, { useState, useEffect, useRef } from "react";
import ReportCount from "../reports/ReportCount";
import updateConversionRate from "../../utils/updateConversionRate";
import FieldOptionReportIcon from "./FieldOptionReportIcon";
import FunnelTrackedMetrics from "../reports/FunnelTrackedMetrics";

const FieldOptionReport = (props) => {
  const field_option = props.field_option;
  const field = props.field;
  const element = props.element;
  const idPrefix = props.reportIdPrefix || "";
  const lifetimeCount =
    props.timeframeType == "All Time" &&
    element.data &&
    element.data["fields"] &&
    element.data["fields"][field.slug] &&
    element.data["fields"][field.slug][field_option.value]
      ? element.data["fields"][field.slug][field_option.value]
      : undefined;
  const defaultConversionRate =
    lifetimeCount > 0
      ? ((lifetimeCount / element.conversions) * 100).toFixed(2)
      : 0;

  return (
    <React.Fragment>
      <div
        className="row hard-center element-selection-report text-xl"
        data-element-id={element.id}
        data-report-id-prefix={idPrefix}
        style={{ width: "100%", order: lifetimeCount }}
      >
        <div
          className="element-selection-report-bar"
          style={{
            width:
              props.timeframeType == "All Time"
                ? `${defaultConversionRate}%`
                : undefined,
          }}
        ></div>
        <div className="row hard-center funnel-breakdown-item-row">
          <div className="col-xs-4 funnel-breakdown-question-label">
            <div className="ellipsis" style={{ marginBottom: "5px" }}>
              <span className="funnel-breakdown-question-position">
                <FieldOptionReportIcon
                  field_type={field_option.visual_type}
                  field_option={field_option}
                />
              </span>
              <span className="funnel-breakdown-question-text">
                {field_option.value}
              </span>
            </div>
          </div>
          <div className="col-xs-8 right">
            <p className="light text-xl" style={{ marginBottom: "10px" }}>
              <strong>
                <ReportCount
                  inline={true}
                  count={lifetimeCount}
                  id={`${idPrefix}field-option-${field_option.id}-selections`}
                  path={`/websites/${props.cta.website_id}/events_reports`}
                  payload={{
                    report_type: "distinct_count",
                    report: {
                      website_id: props.cta.website_id,
                      event_type: "Complete",
                      contactable_type: "Cta",
                      contactable_id: props.cta.id,
                      variant_id: props.step.variant_id,
                      step_id: props.step.id,
                      element_id: element.id,
                      field: field.slug,
                      value: field_option.value,
                      range_start: props.range_start,
                      range_end: props.range_end,
                      broadcast_id: null,
                    },
                  }}
                  callback={() => {
                    props.calculationConversionRates();

                    updateConversionRate(
                      `#${idPrefix}field-option-${field_option.id}-selections`,
                      `#${idPrefix}field_option-${field_option.id}-orders`,
                      `#${idPrefix}field_option-${field_option.id}-conversion-rate`
                    );
                  }}
                />
              </strong>{" "}
              selected (
              <span className="conversion-rate">
                {props.timeframeType == "All Time"
                  ? defaultConversionRate
                  : "0.00"}
              </span>
              %)
              <FunnelTrackedMetrics
                layout="details"
                idBase={`${idPrefix}field_option-${field_option.id}`}
                selectionsId={`${idPrefix}field-option-${field_option.id}-selections`}
                path={`/websites/${props.cta.website_id}/events_reports`}
                currency={props.currency}
                gateReports={props.gateReports}
                reportingGoals={props.reportingGoals}
                report={{
                  website_id: props.cta.website_id,
                  range_start: props.range_start,
                  range_end: props.range_end,
                  contactable_type: "Cta",
                  contactable_id: props.cta.id,
                  variant_id: props.step.variant_id,
                  step_id: props.step.id,
                  element_id: element.id,
                  field: field.slug,
                  value: field_option.value,
                  broadcast_id: null,
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FieldOptionReport;
